import React from 'react';

interface LoaderProps {
    text?: string;
}

const Loader: React.FC<LoaderProps> = ({text = "Loading..."}) => {
    return (
        <div className="flex flex-col justify-center items-center gap-4 px-6 py-5">
            {/* Modern dual-ring spinner with gradient */}
            <div className="relative h-10 w-10">
                <div className="absolute inset-0 rounded-full border-2 border-slate-200"/>
                <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-indigo-500 border-r-indigo-500 animate-spin"/>
            </div>
            <p className="text-sm font-medium text-slate-600 tracking-wide">{text}</p>
        </div>
    );
};


interface SpecificComponentLoaderProps {
    text?: string;
    /**
     * When true, overlays its parent with a translucent layer + spinner.
     * When false, renders nothing.
     */
    active?: boolean;
    /** Optional: allow custom background opacity (0–1) */
    opacity?: number;
}

const SpecificComponentLoader: React.FC<SpecificComponentLoaderProps> = ({
                                                                                    text = 'Loading...',
                                                                                    active = false,
                                                                                    opacity = 0.5,
                                                                                }) => {
    if (!active) return null;

    return (
        <div
            className="absolute inset-0 z-30 flex flex-col items-center justify-center gap-3 rounded-lg backdrop-blur-sm"
            style={{backgroundColor: `rgba(255, 255, 255, ${opacity})`}}
        >
            <div className="relative h-8 w-8">
                <div className="absolute inset-0 rounded-full border-2 border-slate-200"/>
                <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-indigo-500 border-r-indigo-500 animate-spin"/>
            </div>
            <p className="text-xs font-medium text-slate-600 tracking-wide">{text}</p>
        </div>
    );
};


export {Loader, SpecificComponentLoader};


